import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { VoiceProduct } from '@shared/models/voice-product.model';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ProductSubscriberUpdateAction } from '@sales/states/customer-product/customer-product.actions';
import { IconNames } from '@shared/enums/icon-names';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { UserDefinerStepComponent } from '../../subscription-stepper/user-definer-step/user-definer-step.component';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IceBackButtonComponent } from '@app/shared/components/atoms/ice-back-button/ice-back-button.component';

@Component({
  selector: 'app-change-user',
  templateUrl: './change-user.component.html',
  styleUrls: ['./change-user.component.scss'],
  imports: [
    IceBackButtonComponent,
    SpinnerComponent,
    FormsModule,
    ReactiveFormsModule,
    UserDefinerStepComponent,
    IceButtonComponent,
  ],
})
export class ChangeUserComponent implements OnChanges {
  private store = inject(Store);

  IconNames = IconNames;

  @Input() product: VoiceProduct;
  @Output() finishedChanging = new EventEmitter();

  groupName = 'user';
  form: FormGroup = new FormGroup({});

  get upperAgeLimit(): number | null {
    return this.product.offering?.id
      ? this.product.offering.upperAgeLimit
      : (this.product.assignedSubscription?.mobilePlan?.productDetails?.upperAgeLimit ?? null);
  }

  get lowerAgeLimit(): number | null {
    return this.product.offering?.id
      ? this.product.offering.lowerAgeLimit
      : (this.product.assignedSubscription?.mobilePlan?.productDetails?.lowerAgeLimit ?? null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedProduct: VoiceProduct = changes.product.currentValue;
    if (changedProduct) {
      this.form.markAsUntouched();
      this.form.markAsPristine();
    }
  }

  onSave() {
    if (this.form.valid) {
      const subscriberFormGroup = this.form.get(this.groupName);
      this.store.dispatch(new ProductSubscriberUpdateAction(this.product.id, subscriberFormGroup.value));
    }
  }
}
